/* CUSTOM_FREIGHTHUB_BY_CLAUDE (Freight Hub H2, Ryan 2026-10-15) - Freight Hub -> GoRocket Truckload Quote Request, the JS half.
   Moved VERBATIM from assets/rep-settings-agent-panels.js when every freight setting left Settings for the
   Freight Hub (decision F3, Freight-Hub/FREIGHT-HUB-PLANNER.md). Markup: snippets/freight-hub-ftl-rfq.liquid, which
   also loads this file. Same routes, same fields, same save bodies as before the move.
   showMsg / hideMsg are copies of that file's IIFE-local helpers. */
(function() {
  'use strict';
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) {
    if (!el) return;
    el.className = 'rep-settings__message';
  }
  function init() {
    if (!window.RepPortal || !window.RepPortal.API) return;
/* CUSTOM_FTLRFQ_BY_CLAUDE (AIOPS 2939a5f9ee9e, Ryan 2026-09-17) — Admin: GoRocket Truckload Quote
   Request. TWO buttons over ONE record (GET/POST /admin/ftl-rfq-config), and each POSTs only its
   own fields — the route treats an omitted field as "keep what is stored", so the switch and the
   thresholds cannot clobber each other. Nothing is defaulted in the markup: the tick and the three
   numbers are read from the server, because a default written twice is a screen that goes on
   showing the old one the first time the worker changes its mind. */
var ftlEnabled = document.getElementById('settings-ftlrfq-enabled');
var ftlBtn = document.getElementById('settings-ftlrfq-btn');
var ftlMsg = document.getElementById('settings-ftlrfq-msg');
var ftlCeiling = document.getElementById('settings-ftlrfq-ceiling');
var ftlWeight = document.getElementById('settings-ftlrfq-weight');
var ftlUnits = document.getElementById('settings-ftlrfq-units');
var ftlThreshBtn = document.getElementById('settings-ftlrfq-thresholds-btn');
var ftlThreshMsg = document.getElementById('settings-ftlrfq-thresholds-msg');
var costRatio = document.getElementById('settings-costguard-ratio');   // CUSTOM_COSTGUARD_BY_CLAUDE
var costOver = document.getElementById('settings-costguard-over');     // CUSTOM_COSTGUARD_BY_CLAUDE
var costBtn = document.getElementById('settings-costguard-btn');       // CUSTOM_COSTGUARD_BY_CLAUDE
var costMsg = document.getElementById('settings-costguard-msg');       // CUSTOM_COSTGUARD_BY_CLAUDE
if (ftlBtn && ftlEnabled) {
  var ftlPaint = function(c) {
    ftlEnabled.checked = !!(c && c.enabled === true);
    if (ftlCeiling && c && c.ltlCeilingUsd != null) ftlCeiling.value = c.ltlCeilingUsd;
    if (ftlWeight && c && c.ftlWeightLb != null) ftlWeight.value = c.ftlWeightLb;
    if (ftlUnits && c && c.ftlHandlingUnits != null) ftlUnits.value = c.ftlHandlingUnits;
    if (costRatio && c && c.chargeRatio != null) costRatio.value = c.chargeRatio;     // CUSTOM_COSTGUARD_BY_CLAUDE
    if (costOver && c && c.chargeOverUsd != null) costOver.value = c.chargeOverUsd;   // CUSTOM_COSTGUARD_BY_CLAUDE
  };
  (async function loadFtl() {
    try {
      ftlPaint(await window.RepPortal.API.get('/admin/ftl-rfq-config'));
    } catch (e) {
      showMsg(ftlMsg, 'Could not load the current setting — reload before saving.', 'error');
    }
  })();
  ftlBtn.addEventListener('click', async function() {
    hideMsg(ftlMsg);
    ftlBtn.disabled = true;
    var orig = ftlBtn.textContent;
    ftlBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/ftl-rfq-config', { enabled: !!ftlEnabled.checked });
      if (res && res.error) throw new Error(res.error);
      ftlPaint(res);
      showMsg(ftlMsg, res && res.enabled
        ? 'Saved — the truckload quote request can now go live to ' + (res.to || 'GoRocket') + '. It is still a human who sends it.'
        : 'Saved — nothing goes to the broker. The preview still renders and a [TEST] still reaches ryan@.', 'success');
    } catch (e) {
      showMsg(ftlMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      ftlBtn.disabled = false;
      ftlBtn.textContent = orig;
    }
  });
}
if (ftlThreshBtn && ftlCeiling) {
  ftlThreshBtn.addEventListener('click', async function() {
    hideMsg(ftlThreshMsg);
    ftlThreshBtn.disabled = true;
    var orig = ftlThreshBtn.textContent;
    ftlThreshBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/ftl-rfq-config', {
        ltlCeilingUsd: parseFloat(ftlCeiling.value),
        ftlWeightLb: parseFloat(ftlWeight && ftlWeight.value),
        ftlHandlingUnits: parseFloat(ftlUnits && ftlUnits.value),
      });
      if (res && res.error) throw new Error(res.error);
      if (ftlCeiling) ftlCeiling.value = res.ltlCeilingUsd;
      if (ftlWeight) ftlWeight.value = res.ftlWeightLb;
      if (ftlUnits) ftlUnits.value = res.ftlHandlingUnits;
      showMsg(ftlThreshMsg, 'Saved — a shipment counts as a truckload over $' + res.ltlCeilingUsd
        + ', or at ' + res.ftlWeightLb + ' lb, or at ' + res.ftlHandlingUnits + ' pallets.', 'success');
    } catch (e) {
      showMsg(ftlThreshMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      ftlThreshBtn.disabled = false;
      ftlThreshBtn.textContent = orig;
    }
  });
}
/* CUSTOM_COSTGUARD_BY_CLAUDE (AIOPS e66d773e3c73, Ryan 2026-09-25) — the cost pause's own button over
   the same record; it POSTs only its two fields, so it cannot clobber the switch or the truckload numbers. */
if (costBtn && costRatio && costOver) {
  costBtn.addEventListener('click', async function() {
    hideMsg(costMsg);
    costBtn.disabled = true;
    var orig = costBtn.textContent;
    costBtn.textContent = 'Saving...';
    try {
      var res = await window.RepPortal.API.post('/admin/ftl-rfq-config', {
        chargeRatio: parseFloat(costRatio.value),
        chargeOverUsd: parseFloat(costOver.value),
      });
      if (res && res.error) throw new Error(res.error);
      costRatio.value = res.chargeRatio;
      costOver.value = res.chargeOverUsd;
      showMsg(costMsg, 'Saved — a GoRocket rate is refused at ' + res.chargeRatio + 'x the charged freight, or $'
        + res.chargeOverUsd + ' over it.', 'success');
    } catch (e) {
      showMsg(costMsg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
    } finally {
      costBtn.disabled = false;
      costBtn.textContent = orig;
    }
  });
}
/* END CUSTOM_COSTGUARD_BY_CLAUDE */
/* END CUSTOM_FTLRFQ_BY_CLAUDE */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END CUSTOM_FREIGHTHUB_BY_CLAUDE */
